/**
 * Banner Block
 *
 * Toggles aria-expanded on .banner-block__above-text when clicked.
 */
export default function bannerBlock() {
	const triggers = document.querySelectorAll('.banner-block__above-text');

	if (triggers.length === 0) return;

	triggers.forEach((trigger) => {
		trigger.addEventListener('click', () => {
			const expanded = trigger.getAttribute('aria-expanded');
			trigger.setAttribute('aria-expanded', expanded === 'true' ? 'false' : 'true');
		});
	});
}
